module.exports = __webpack_public_path__ + "static/media/boiler-room.cd7fe0c4.png";